import _Promise from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/promise';
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

var _cae3002a = function _cae3002a() {
	return import('../pages/comboBook/index.vue' /* webpackChunkName: "pages/comboBook/index" */).then(function (m) {
		return m.default || m;
	});
};
var _19b2aeb0 = function _19b2aeb0() {
	return import('../pages/dashboard/index.vue' /* webpackChunkName: "pages/dashboard/index" */).then(function (m) {
		return m.default || m;
	});
};
var _35dd50ea = function _35dd50ea() {
	return import('../pages/fieldsOperationPortal.vue' /* webpackChunkName: "pages/fieldsOperationPortal" */).then(function (m) {
		return m.default || m;
	});
};
var _6b6639a9 = function _6b6639a9() {
	return import('../pages/functionTesting.vue' /* webpackChunkName: "pages/functionTesting" */).then(function (m) {
		return m.default || m;
	});
};
var _3214b653 = function _3214b653() {
	return import('../pages/initPortalBeforeProduction.vue' /* webpackChunkName: "pages/initPortalBeforeProduction" */).then(function (m) {
		return m.default || m;
	});
};
var _5a79cc2c = function _5a79cc2c() {
	return import('../pages/mainPage/index.vue' /* webpackChunkName: "pages/mainPage/index" */).then(function (m) {
		return m.default || m;
	});
};
var _107db6df = function _107db6df() {
	return import('../pages/tvCalendar.vue' /* webpackChunkName: "pages/tvCalendar" */).then(function (m) {
		return m.default || m;
	});
};
var _5a7e22c0 = function _5a7e22c0() {
	return import('../pages/dashboard/management/index.vue' /* webpackChunkName: "pages/dashboard/management/index" */).then(function (m) {
		return m.default || m;
	});
};
var _7d5569b4 = function _7d5569b4() {
	return import('../pages/dashboard/moduleSessionReport.vue' /* webpackChunkName: "pages/dashboard/moduleSessionReport" */).then(function (m) {
		return m.default || m;
	});
};
var _1548f126 = function _1548f126() {
	return import('../pages/dashboard/pending.vue' /* webpackChunkName: "pages/dashboard/pending" */).then(function (m) {
		return m.default || m;
	});
};
var _e651e9d4 = function _e651e9d4() {
	return import('../pages/dashboard/registration/index.vue' /* webpackChunkName: "pages/dashboard/registration/index" */).then(function (m) {
		return m.default || m;
	});
};
var _b02bb9e6 = function _b02bb9e6() {
	return import('../pages/dashboard/viewInfo.vue' /* webpackChunkName: "pages/dashboard/viewInfo" */).then(function (m) {
		return m.default || m;
	});
};
var _ba358b9a = function _ba358b9a() {
	return import('../pages/dashboard/management/_userId.vue' /* webpackChunkName: "pages/dashboard/management/_userId" */).then(function (m) {
		return m.default || m;
	});
};
var _2fe61129 = function _2fe61129() {
	return import('../pages/dashboard/registration/_userId.vue' /* webpackChunkName: "pages/dashboard/registration/_userId" */).then(function (m) {
		return m.default || m;
	});
};
var _1e08b421 = function _1e08b421() {
	return import('../pages/mainPage/_mid.vue' /* webpackChunkName: "pages/mainPage/_mid" */).then(function (m) {
		return m.default || m;
	});
};
var _4b2d15a3 = function _4b2d15a3() {
	return import('../pages/index.vue' /* webpackChunkName: "pages/index" */).then(function (m) {
		return m.default || m;
	});
};

if (process.client) {
	window.history.scrollRestoration = 'manual';
}
var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
	// if the returned position is falsy or an empty object,
	// will retain current scroll position.
	var position = false;

	// if no children detected
	if (to.matched.length < 2) {
		// scroll to the top of the page
		position = { x: 0, y: 0 };
	} else if (to.matched.some(function (r) {
		return r.components.default.options.scrollToTop;
	})) {
		// if one of the children has scrollToTop option set to true
		position = { x: 0, y: 0 };
	}

	// savedPosition is only available for popstate navigations (back button)
	if (savedPosition) {
		position = savedPosition;
	}

	return new _Promise(function (resolve) {
		// wait for the out transition to complete (if necessary)
		window.$nuxt.$once('triggerScroll', function () {
			// coords will be used if no selector is provided,
			// or if the selector didn't match any element.
			if (to.hash) {
				var hash = to.hash;
				// CSS.escape() is not supported with IE and Edge.
				if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
					hash = '#' + window.CSS.escape(hash.substr(1));
				}
				try {
					if (document.querySelector(hash)) {
						// scroll to anchor by returning the selector
						position = { selector: hash };
					}
				} catch (e) {
					console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
				}
			}
			resolve(position);
		});
	});
};

export function createRouter() {
	return new Router({
		mode: 'history',
		base: '/',
		linkActiveClass: 'nuxt-link-active',
		linkExactActiveClass: 'nuxt-link-exact-active',
		scrollBehavior: scrollBehavior,
		routes: [{
			path: "/comboBook",
			component: _cae3002a,
			name: "comboBook"
		}, {
			path: "/dashboard",
			component: _19b2aeb0,
			name: "dashboard"
		}, {
			path: "/fieldsOperationPortal",
			component: _35dd50ea,
			name: "fieldsOperationPortal"
		}, {
			path: "/functionTesting",
			component: _6b6639a9,
			name: "functionTesting"
		}, {
			path: "/initPortalBeforeProduction",
			component: _3214b653,
			name: "initPortalBeforeProduction"
		}, {
			path: "/mainPage",
			component: _5a79cc2c,
			name: "mainPage"
		}, {
			path: "/tvCalendar",
			component: _107db6df,
			name: "tvCalendar"
		}, {
			path: "/dashboard/management",
			component: _5a7e22c0,
			name: "dashboard-management"
		}, {
			path: "/dashboard/moduleSessionReport",
			component: _7d5569b4,
			name: "dashboard-moduleSessionReport"
		}, {
			path: "/dashboard/pending",
			component: _1548f126,
			name: "dashboard-pending"
		}, {
			path: "/dashboard/registration",
			component: _e651e9d4,
			name: "dashboard-registration"
		}, {
			path: "/dashboard/viewInfo",
			component: _b02bb9e6,
			name: "dashboard-viewInfo"
		}, {
			path: "/dashboard/management/:userId",
			component: _ba358b9a,
			name: "dashboard-management-userId"
		}, {
			path: "/dashboard/registration/:userId",
			component: _2fe61129,
			name: "dashboard-registration-userId"
		}, {
			path: "/mainPage/:mid",
			component: _1e08b421,
			name: "mainPage-mid"
		}, {
			path: "/",
			component: _4b2d15a3,
			name: "index"
		}],

		fallback: false
	});
}


//////////////////
// WEBPACK FOOTER
// ./.nuxt/router.js
// module id = ./.nuxt/router.js
// module chunks = 20